module.exports = __webpack_public_path__ + "img/exam-result-none.7f76dac1.svg";